// import { useState } from 'react';
import { useEffect, useRef, useState } from 'react';
import DualRangeSlider from '../DualThumbSlider/DualRangeSlider';
import './productsfilter.scss';
import { ChevronRight, Filter, ChevronDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

type Prop = {
    toggle: boolean,
    setToggle: React.Dispatch<React.SetStateAction<boolean>>;
    processPriceFilter:(priceData:any) => void
}


const ProductsFilter = ({ toggle, setToggle,processPriceFilter }: Prop) => {

    const mobileRef = useRef<HTMLDivElement>(null);
    // const dropdownClicker= useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                toggle &&
                mobileRef.current &&
                !mobileRef.current.contains(event.target as Node)
            ) {
                setToggle(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line 
    }, [toggle]);

    const dropdownRef = useRef<HTMLDivElement>(null);
    const togglerRef = useRef<HTMLDivElement>(null);

   const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node;

  if (
    dropdownRef.current &&
    !dropdownRef.current.contains(target) &&
    togglerRef.current &&
    !togglerRef.current.contains(target)
  ) {
    setPriceFilter(prev => ({
      ...prev,
      toggleOpt: false
    }));
  }
};

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

    const [priceFilter, setPriceFilter] = useState({
        defaultRange: {
            min: 0,
            max: 250000
        },
        customRange: {
            min: 0,
            max: 0
        },
        step: 100,
        currency_symbol: '₦',
        toggleOpt: false,
        rangeOpts: [
            {
                min: 0,
                max: 250000,
                step: 2000
            },

            {
                min: 250000,
                max: 1000000,
                step: 20000
            },
            {
                min: 1000000,
                max: 3000000,
                step: 50000

            },
            {
                min: 3000000,
                max: 5000000,
                step: 100000
            },
            // {
            //     min: 5000000,
            //     max: null,
            //     step: 100000
            // }
        ]
    })




    const handleSliderInput = (min: number, max: number) => {
        // console.log(`Selected: ${min} - ${max}`)

        setPriceFilter((prev) => {
            return {
                ...prev,
                customRange: {
                    min: min,
                    max: max
                }
            }
        })
    }

    const toggleRangeOpt = () => {
        setPriceFilter((prev) => {
            return {
                ...prev,
                toggleOpt: !prev.toggleOpt
            }
        })
    }

    const handleSelectRange = (opt: any) => {


         setPriceFilter((prev) => {
            return {
                ...prev,
                 defaultRange: {
            min: opt.min,
            max: opt.max 
        },
        customRange: {
            min: opt.min,
            max: opt.max
        },
                toggleOpt: !prev.toggleOpt,
                step:opt.step
            }
        })



    }

    const applyPriceFilter=()=>{



       let priceObj={
        min:priceFilter.customRange.min,
        max:priceFilter.customRange.max
       }

    //    setPriceFilter((prev)=>{
    //     return {
    //         ...prev,
    //         customRange:{
    //             min:prev.defaultRange.min,
    //             max:prev.defaultRange.max
    //         }
    //     }
    //    })



       processPriceFilter(priceObj)


        setToggle(false)


    }



    return (
        <div className="productsfilter">

            <div className='web'>

                <div className='filter_title'>

                    <Filter size={18}></Filter>
                    <div>Filter By</div>
                </div>


                <div className='filterCont'>

                    <div className='eachFilter'>

                        <div className='acFlex'>
                            <div className='title'>Price</div>
                            <div className='apply' onClick={applyPriceFilter}>Apply</div>
                        </div>



                        <DualRangeSlider
                            min={priceFilter.defaultRange.min}
                            max={priceFilter.defaultRange.max}
                            step={priceFilter.step}
                            onChange={(min, max) => handleSliderInput(min, max)}
                        />


                        <div className="pAreaFlex">

                            <div className='priceArea'>


                            <div className='shortInputArea'>
                                <div className='input'>{`${priceFilter.currency_symbol}${(priceFilter.customRange.min).toLocaleString()}`}</div>
                            </div>

                            <hr className='midline'></hr>

                            <div className='shortInputArea'>
                                <div className='input'>{`${priceFilter.currency_symbol}${(priceFilter.customRange.max).toLocaleString()}`}</div>
                            </div>

                            </div>

                            <div className='flex_hj' onClick={toggleRangeOpt} ref={togglerRef}>

                                <div className='selc'>Select Range</div>


                                  <div className='dropIcon'  >
                                <motion.div
                                    animate={{ rotate: priceFilter.toggleOpt ? 180 : 0 }}
                                    transition={{ duration: 0.2, ease: 'easeInOut' }}
                                >
                                    <ChevronDown size={22}  />
                                </motion.div>
                            </div>

                            </div>


                          


                        </div>

                        <div className="dropdown" ref={dropdownRef}>
                            <AnimatePresence>
                                {priceFilter.toggleOpt && (
                                    <motion.div
                                        className="dropdown-menu"
                                        initial={{ opacity: 0, y: -10, scale: 0.95 }}
                                        animate={{ opacity: 1, y: 0, scale: 1 }}
                                        exit={{ opacity: 0, y: -10, scale: 0.95 }}
                                        transition={{ duration: 0.3, ease: 'easeOut' }}
                                    >
                                        {priceFilter.rangeOpts.map((option, id) => (
                                            <div
                                                key={id}
                                                className="dropdown-item"
                                                onClick={() => handleSelectRange(option)}
                                            >
                                                {priceFilter.currency_symbol}
                                                {(option.min).toLocaleString()} - {priceFilter.currency_symbol}
                                                {(option.max || '+').toLocaleString()}
                                            </div>
                                        ))}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>

                    </div>


                </div>

            </div>


            <AnimatePresence>

                {toggle && (<div className='overlay'>
                    <motion.div className='mobile'
                        initial={{ opacity: 0, x: -10, width: 0 }}
                        animate={{
                            opacity: 1, x: 0, width: "280px", transition: {
                                // type: "spring",
                                // stiffness: 400,
                                // damping: 20,
                                // bounce: 0.3,

                                type: "tween",
                                duration: 0.2,
                                ease: "easeOut",
                            }
                        }}
                        exit={{
                            opacity: 0, x: -10, width: 0, transition: {
                                type: "tween",
                                duration: 0.2,
                                ease: "easeOut",
                            }
                        }}
                        ref={mobileRef}
                    >
                        <button className="close-button" onClick={() => setToggle(false)} >
                            {/* <X size={20}></X> */}
                            <ChevronRight size={30}></ChevronRight>
                        </button>

                        <div className='filter'>

                            <div className='filter_title'>

                                <Filter size={18}></Filter>
                                <div>Filter By</div>
                            </div>


                            <div className='filterCont'>

                                <div className='eachFilter'>

                                    <div className='acFlex'>
                                        <div className='title'>Price</div>
                                        <div className='apply' onClick={applyPriceFilter}>Apply</div>
                                    </div>

                                    <DualRangeSlider
                                        min={priceFilter.defaultRange.min}
                                        max={priceFilter.defaultRange.max}
                                        step={priceFilter.step}
                                        onChange={(min, max) => handleSliderInput(min, max)}
                                    />


                                     <div className="pAreaFlex">

                            <div className='priceArea'>


                            <div className='shortInputArea'>
                                <div className='input'>{`${priceFilter.currency_symbol}${(priceFilter.customRange.min).toLocaleString()}`}</div>
                            </div>

                            <hr className='midline'></hr>

                            <div className='shortInputArea'>
                                <div className='input'>{`${priceFilter.currency_symbol}${(priceFilter.customRange.max).toLocaleString()}`}</div>
                            </div>

                            </div>

                            <div className='flex_hj' onClick={toggleRangeOpt} ref={togglerRef}>

                                <div className='selc'>Select Range</div>


                                  <div className='dropIcon'  >
                                <motion.div
                                    animate={{ rotate: priceFilter.toggleOpt ? 180 : 0 }}
                                    transition={{ duration: 0.2, ease: 'easeInOut' }}
                                >
                                    <ChevronDown size={22}  />
                                </motion.div>
                            </div>

                            </div>


                          


                        </div>

                        <div className="dropdown" ref={dropdownRef}>
                            <AnimatePresence>
                                {priceFilter.toggleOpt && (
                                    <motion.div
                                        className="dropdown-menu"
                                        initial={{ opacity: 0, y: -10, scale: 0.95 }}
                                        animate={{ opacity: 1, y: 0, scale: 1 }}
                                        exit={{ opacity: 0, y: -10, scale: 0.95 }}
                                        transition={{ duration: 0.3, ease: 'easeOut' }}
                                    >
                                        {priceFilter.rangeOpts.map((option, id) => (
                                            <div
                                                key={id}
                                                className="dropdown-item"
                                                onClick={() => handleSelectRange(option)}
                                            >
                                                {priceFilter.currency_symbol}
                                                {(option.min).toLocaleString()} - {priceFilter.currency_symbol}
                                                {(option.max || '+').toLocaleString()}
                                            </div>
                                        ))}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>

                                </div>


                            </div>
                        </div>

                    </motion.div>
                </div>)}

            </AnimatePresence>





        </div>)
}


export default ProductsFilter